var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIconDisableLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.05C18.0074 16.05 17 17.0574 17 18.3V31.8C17 33.0427 18.0074 34.05 19.25 34.05H21.75C22.9926 34.05 24 33.0427 24 31.8V18.3C24 17.0574 22.9926 16.05 21.75 16.05H19.25ZM18.5 18.3C18.5 17.8858 18.8358 17.55 19.25 17.55H21.75C22.1642 17.55 22.5 17.8858 22.5 18.3V31.8C22.5 32.2143 22.1642 32.55 21.75 32.55H19.25C18.8358 32.55 18.5 32.2143 18.5 31.8V18.3ZM28.25 16.05C27.0074 16.05 26 17.0574 26 18.3V31.8C26 33.0427 27.0074 34.05 28.25 34.05H30.75C31.9926 34.05 33 33.0427 33 31.8V18.3C33 17.0574 31.9926 16.05 30.75 16.05H28.25ZM27.5 18.3C27.5 17.8858 27.8358 17.55 28.25 17.55H30.75C31.1642 17.55 31.5 17.8858 31.5 18.3V31.8C31.5 32.2143 31.1642 32.55 30.75 32.55H28.25C27.8358 32.55 27.5 32.2143 27.5 31.8V18.3Z",
    fill: "#06B6D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIconDisableLight);
export default __webpack_public_path__ + "static/media/pauseIconDisableLight.8dd465f0bc90e1230d9ec31bef5b4512.svg";
export { ForwardRef as ReactComponent };